<template>
	<div class="content">
		<van-nav-bar
		  title="个人中心"
		  @click-left="onClickLeft"
		  left-arrow
		  
		/>
		<van-row class="text">
			  <van-col span="12" class='img'>头像</van-col>
			 
			  <van-col span="12" class='img'>
			  	<el-image style="width:48px; height: 48px ;padding-top: 2px;" :src="headPhoto"></el-image>
			 <!-- <img class='wx_img' src="../../../../static/mj.jpg">-->
			  </van-col>
			  
			  <van-col span="12" class='text_'>微信名称</van-col>
			  <van-col span="12" class='text_'>{{name}}</van-col>
			  <van-col span="12" class='text_'>地区</van-col>
			  <van-col span="12" class='text_'>{{dizhi}}</van-col>
			  <van-cell title="订单详情" is-link @click="order()"  style="color:#39A9ED"/>
			 <!-- <van-cell title="进出明细" is-link />-->
		</van-row>
		<van-tabbar v-model="active">
			    <van-tabbar-item icon="home-o" @click="home()">购票首页</van-tabbar-item>
				<van-tabbar-item icon="setting-o"  @click="user()">个人中心</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
export default {
  data () {
    return {
    	headPhoto:'',
          foo: 'bar',
	      active: 1,
		  tel: '',
	      text: '',
	      digit: '',
	      number: '',
	      dizhi:"",
	      name:'',
	    }
    },
      mounted(){
    	this.userlist();
    },
	methods: {
		userlist(){
			let storage=window.sessionStorage;
    		let openid = storage.getItem("openid")
			this.$axios({
					url: "/api/wechat/findWXUser",
					method: "get",
					params: {
						openid: openid,
					}
				})
			.then(res => {
				 var data = res.data[0];
				 this.headPhoto= data.headimgurl;
				 this.dizhi= data.country +  data.province +  data.city ;
				 this.name =data.nickname;
				 console.log(data)
			 
			 })
			.catch(err => {
				console.log(err);
			});
		},
	     home(){
	        this.$router.push({ path: "/mn_ticketIndex"});
	    },
	    user(){
	    	 this.$router.push({ path: "/mn_ticketUser" });
	    },
		order(){
			this.$router.push({ path: "/mn_ticketOrderlist" });
		},
		 onClickLeft(){
	    	this.$router.go(-1);//返回上一层
			//this.$router.push({ path: "/wx_ticketUser",query: { total: total , numlist: numlist }  });
		},
	  /*  onClickLeft() {
      Toast('返回');
	    }*/
	   
	   
	  }
  
}
</script>

<style scoped>
	
	.content{
		width: 100%;
		height: 100%;
		background-color: #FFFFFF;
	}
	.img {
		border-top: 1px solid gainsboro;
		height: 60px;
		line-height: 60px;
		padding-left: 16px;
	}
	.wx_img{
		width: 58px;
		height: 58px;
		background-size: cover;
		
	}
	.text_{
		height: 40px;
		line-height: 40px;
		padding-left: 16px;
	}
	.text{
		font-size: 14px;
		text-align: left;
	}
</style>


// WEBPACK FOOTER //
// src/system/index/wechatlistmini/mn_ticketUser.vue